import React, { useState } from "react";

function ShareWithCommunityField({ onChange, disabled }) {

    // const onChange = (value) => {
    //     storeService.changeRule({...rule, [ruleKey]: value})
    // }

    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = () => {
        // Do nothing if the checkbox is disabled
        // if (isChecked) {
        //     return;
        // }

        // Toggle the checkbox state
        setIsChecked(!isChecked);
    };

    return (
        <label className="addrules-checkbox-item-v2">
            <input
                type="checkbox"
                checked={isChecked}
                disabled={disabled}
                onChange={disabled ? null : () => handleCheckboxChange()}
            />
            <span className="checkbox-label">Share With Community</span>
        </label>
    )

}


export default ShareWithCommunityField;
